import {
  fetchFromApi,
  optionsForPostRequest,
  optionsForPutRequest,
  optionsForDeleteRequest,
  optionsForPatchRequest,
} from './apiUtils';

const basePath = '/v1/institutions';

const getInstitutionUsers = (institutionId, withDetails = false) => {
  const parameter = withDetails ? '?withDetails=true' : '';
  return fetchFromApi(`${basePath}/${institutionId}/users${parameter}`);
}

const getInstitutionObligations = institutionId =>
  fetchFromApi(`${basePath}/${institutionId}/obligations`);

const saveReporter = (institutionId, data) =>
  fetchFromApi(
    `${basePath}/${institutionId}/user`,
    optionsForPostRequest(data)
  );

const updateReporter = (institutionId, user) =>
  fetchFromApi(
    `${basePath}/${institutionId}/user/${user.publicUserDto.id}`,
    optionsForPutRequest(user)
  );

const deleteReporter = (institutionId, userId) =>
  fetchFromApi(
    `${basePath}/${institutionId}/user/${userId}`,
    optionsForDeleteRequest()
  );

const updateMainUser = (institutionId, userId) =>
  fetchFromApi(
    `${basePath}/${institutionId}/main-user/${userId}`,
    optionsForPutRequest()
  );

const setReporterToObligations = (institutionId, reporterId, obligations) =>
  fetchFromApi(
    `${basePath}/${institutionId}/obligations/reporter/${reporterId}`,
    optionsForPatchRequest(obligations)
  );

export default {
  getInstitutionUsers,
  saveReporter,
  updateReporter,
  deleteReporter,
  updateMainUser,
  getInstitutionObligations,
  setReporterToObligations,
};
